import React from "react";
import { useDispatch } from "react-redux";
import { Modal } from "components/ui-kit/Modal/Modal";
import { tradeGroupThunks } from "action-thunks/tradeGroup-thunks";
import styles from "./styles.module.scss";

const OnboardingUpgradeConfirmationModal = ({ item, closeModal, onUpgradeSuccess }) => {
  const dispatch = useDispatch();
  const { personal } = item.item;

  const handleUpgradeConfirm = () => {
    // Send the same request as cabinet project - upgrade simulator endpoint
    const email = personal?.email;
    dispatch(tradeGroupThunks.upgradeSimulatorTC(email));
    closeModal();
    
    // Call success callback to handle UI updates
    if (onUpgradeSuccess) {
      onUpgradeSuccess();
    }
  };

  return (
    <div className="modal-window">
      <Modal
        className="cabinet-modals"
        overlayClassName="request-overlay"
        styleType="zimtra-primary"
        isOpen={true}
        hideBlur
        hasCloseIcon={false}
        onClickOutside={closeModal}
      >
        <Modal.Header
          className="modal-inner-header"
          onClose={closeModal}
          title={
            <h2 className="zimtra-h2">
              {`${personal.firstName} ${personal.lastName}`} - Upgrade to Live Account
            </h2>
          }
        />
        <Modal.Body className="modal-inner-body">
          <div className={styles.upgradeWarning}>
            <div className={styles.warningIcon}>
              ⚠️
            </div>
            <div className={styles.warningContent}>
              <h3>This action is irreversible</h3>
              <p>
                You are about to upgrade this simulator account to a live trading account. 
                This action cannot be undone and will permanently convert the simulator account.
              </p>
              <ul>
                <li>The simulator account will be hidden from the list</li>
                <li>A new live trading account will be created</li>
                <li>You will need to complete live account setup requirements</li>
              </ul>
              <p className={styles.confirmText}>
                <strong>Are you sure you want to proceed with the upgrade?</strong>
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-inner-footer d-flex justify-content-center">
          <button
            className="main-button cancel-button"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className="main-button"
            onClick={handleUpgradeConfirm}
          >
            Yes, Upgrade to Live Account
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OnboardingUpgradeConfirmationModal;
